class LookbookCarousel extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    const slider = this.querySelector(".swiper-lookbook");
    if (!slider) return;

    // swiper-bundle.min.js is loaded deferred globally; retry until it is ready
    if (!window.Swiper) {
      setTimeout(() => this.init(), 100);
      return;
    }

    const autoplay = this.dataset.autoplay === "true";
    const delay = this.dataset.delay ? Number(this.dataset.delay) : 5000;
    const options = {
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
    };

    if (autoplay) {
      options.autoplay = { delay, disableOnInteraction: false };
    }

    new Swiper(slider, options);
  }
}

if (!customElements.get("lookbook-carousel")) {
  customElements.define("lookbook-carousel", LookbookCarousel);
}
